import { render, staticRenderFns } from "./NSaleInviteRegister.vue?vue&type=template&id=22f1d410&scoped=true"
import script from "./NSaleInviteRegister.vue?vue&type=script&lang=js"
export * from "./NSaleInviteRegister.vue?vue&type=script&lang=js"
import style0 from "./NSaleInviteRegister.vue?vue&type=style&index=0&id=22f1d410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1d410",
  null
  
)

export default component.exports